import base from './base2.repository';
import handleErrors from '../utils/handleErrors';
export default {
    get: (resource, params, errMsg = null) => ({ ...base }).get(resource, params).catch(err => handleErrors(err, errMsg)),
    post: (resource, payload) => ({ ...base }).post(resource, payload).catch(handleErrors),
    put: (resource, payload) => ({ ...base }).put(resource, payload).catch(handleErrors),
    delete: (resource, payload) => ({ ...base }).delete(resource, payload).catch(handleErrors),
}